import React from 'react';
import { formatCurrency } from '../../utils/invoiceUtils';

const InvoiceLinesTable = ({ lines, onEdit, onDelete, showActions = true }) => {
  const formatPeriod = (start, end) => {
    if (!start && !end) return '-';
    const formatDate = (value) => {
      if (!value) return '-';
      const parsed = new Date(value);
      if (Number.isNaN(parsed.getTime())) return '-';
      return parsed.toLocaleDateString('es-ES');
    };
    return `${formatDate(start)} - ${formatDate(end)}`;
  };
  if (!lines?.length) {
    return (
      <p className="text-muted small mb-0">
        {showActions ? 'Sin líneas. Añade la primera línea.' : 'Sin líneas disponibles.'}
      </p>
    );
  }
  return (
    <div className="table-responsive">
      <table className="table table-sm">
        <thead>
          <tr>
            <th>Concepto</th>
            <th>Periodo</th>
            <th>Cant.</th>
            <th>Precio</th>
            <th>Dto.</th>
            <th>IVA</th>
            <th>Subtotal</th>
            {showActions && <th></th>}
          </tr>
        </thead>
        <tbody>
          {lines.map((ln, idx) => {
            // El total de la línea es el BRUTO (cantidad * precio); el subtotal aplica el descuento.
            const dto = Number(ln.descuento || 0);
            const gross = ln.total != null ? Number(ln.total) : Number(ln.cantidad || 0) * Number(ln.precio || 0);
            const net = Math.round(gross * (1 - dto / 100) * 100) / 100;
            return (
            <tr key={ln.id || `${ln.concepto}-${ln.created_at || ''}-${idx}`}>
              <td>{ln.concepto}</td>
              <td className="small text-muted">{formatPeriod(ln.period_start, ln.period_end)}</td>
              <td>{ln.cantidad}</td>
              <td>{formatCurrency(ln.precio)}</td>
              <td>{dto > 0 ? `${dto}%` : '-'}</td>
              <td>{ln.tva_tx != null ? `${Number(ln.tva_tx)}%` : '21%'}</td>
              <td>{formatCurrency(net)}</td>
              {showActions && (
                <td className="text-end">
                  <button className="btn btn-sm btn-outline-secondary me-2" type="button" onClick={() => onEdit?.(ln)}>Editar</button>
                  <button className="btn btn-sm btn-outline-danger" type="button" onClick={() => onDelete?.(ln.id)}>Eliminar</button>
                </td>
              )}
            </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default InvoiceLinesTable;
